import { Injectable } from '@angular/core';
// import { GetOptions, RemoveOptions, SetOptions, Storage } from '@capacitor/storage';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setStorage(key: string, value) {
    //let obj: SetOptions = {key: key+'', value: value+''};
    //console.log({key: key, value: value});

    return Preferences.set({key: key, value: value});
  }

  getStorage(key: string) {
    //let obj: GetOptions = {key: key+''};
    return Preferences.get({key: key});
  }

  removeStorage(key: string) {
    //let obj: RemoveOptions = {key: key+''};
    Preferences.remove({key: key});
  }
}
